<script lang="ts">
  import { userbaseStore } from "../../stores/stores";
  import Card from "../../shared/Card.svelte";
  import Button from "../../shared/Button.svelte";
  import Modal from "../../shared/Modal.svelte";
  import UpdateEntryAdjustForm from "./UpdateEntryAdjustForm.svelte";
  import UpdateEntryAddForm from "./UpdateEntryAddForm.svelte";
  import UpdateEntryUseForm from "./UpdateEntryUseForm.svelte";
  import moment from "moment";
  import { afterUpdate, onMount } from "svelte";
  import { FormType, ArticleType, DatabaseName } from "../../stores/types";
  import type { Entry, DBInventoryEntry } from "../../stores/types";

  moment.defaultFormat = "DD.MM.YYYY";

  export let dbEntry: DBInventoryEntry, itemId: string;

  let showDetailModal = false;
  let addForm = false;
  let formType = null;
  let amountAlert = false;
  let freshnessAlert = false;
  let dbNameInventory = DatabaseName.INVENTORY.toString();
  let freshness = 0;
  let entryPromise = null;
  let logPromise = null;

  let inventoryItem: Entry = dbEntry.item;

  let sauerteig: boolean = false;
  /*  if (inventoryItem.article.item.type === ArticleType.SAUERTEIG.toString()) {
    sauerteig = true;
  } */

  onMount(() => {
    redrawItem();
  });

  afterUpdate(() => {
    redrawItem();
  });

  const toggleModal = () => {
    showDetailModal = !showDetailModal;
  };

  // redraw to alert
  const redrawItem = () => {
    var difference = 0;
    var dateBestBefore = Number(new Date(inventoryItem.bestBefore));
    var today = Number(new Date());
    difference = dateBestBefore - today;
    freshness = Math.round(difference / (1000 * 60 * 60 * 24));
    if (freshness < 60) {
      freshnessAlert = true;
    } else {
      freshnessAlert = false;
    }
    if (
      inventoryItem.amount < 300 &&
      inventoryItem.article.item.type != ArticleType.SAUERTEIG
    ) {
      amountAlert = true;
    } else {
      amountAlert = false;
    }
  };

  // add item
  const handleAdd = () => {
    formType = FormType.ADD;
    showDetailModal = true;
  };

  // use item
  const handleUse = () => {
    addForm = false;
    formType = FormType.USE;
    showDetailModal = true;
  };

  // delete item
  const handleDelete = () => {
    if (confirm("really delete this item?:   ")) {
      var logItem = {
        action: "delete",
        changedItem: inventoryItem,
      };
      logPromise = $userbaseStore.insertItem({
        databaseName: "logs",
        item: logItem,
      });
      entryPromise = $userbaseStore.deleteItem({
        databaseName: dbNameInventory,
        itemId,
      });
    }
    redrawItem();
  };

  // adjust amount
  const handleAdjust = () => {
    formType = FormType.ADJUST;
    showDetailModal = true;
  };

  // update ingredient
  const updateitem = (e) => {
    showDetailModal = false;
    redrawItem();
  };
</script>

<Modal showModal={showDetailModal} on:click={toggleModal}>
  {#if formType === FormType.ADD}
    <UpdateEntryAddForm {inventoryItem} {itemId} on:updateItem={updateitem} />
  {:else if formType === FormType.USE}
    <UpdateEntryUseForm {inventoryItem} {itemId} on:updateItem={updateitem} />
  {:else if formType === FormType.ADJUST}
    <UpdateEntryAdjustForm
      {inventoryItem}
      {itemId}
      on:updateItem={updateitem}
    />
  {/if}
</Modal>
<Card>
  <div class="ingredient">
    <div class="header">
      <h3 class="subtitle is-3">{inventoryItem.article.item.name}</h3>
      <span class="tag" class:sauerteig>{inventoryItem.article.item.type}</span>
      <div class="delete-item" title="Delete item">
        <span class="icon-button"
          ><i class="fas fa-trash-alt" on:click={() => handleDelete()} /></span
        >
      </div>
    </div>
    <div class="amountbox">
      <div class="amount">
        <div class="value" class:amountAlert>{inventoryItem.amount} g</div>
        <div class="bestBefore" class:freshnessAlert>
          <br />(Best before: {moment(inventoryItem.bestBefore).format()})
        </div>
      </div>
      <div class="adjust">
        <span class="icon-button">
          <i
            class="fas fa-sliders-h"
            title="Menge anpassen"
            on:click={() => handleAdjust()}
          />
        </span>
      </div>
    </div>
    <div class="buttons">
      <Button type="secondary" on:click={() => handleAdd()}>
        <div class="updateDate" title="Eingekauft">
          <div>
            <div class="label">Last added:</div>
            <div class="date">
              {moment(inventoryItem.lastAdded).format()}
            </div>
          </div>
          <div>
            <span style="font-size:medium; color:white; margin-left: 10px;"
              ><i class="fas fa-plus-circle" /></span
            >
          </div>
        </div>
      </Button>

      <Button type="primary" on:click={() => handleUse()}>
        <div class="updateDate" title="Verwendet">
          <div>
            <div class="label">Last used:</div>
            <div class="date">
              {moment(inventoryItem.lastUsed).format()}
            </div>
          </div>
          <div>
            <span style="font-size:medium; color:white; margin-left: 10px;"
              ><i class="fas fa-minus-circle" /></span
            >
          </div>
        </div>
      </Button>
    </div>
  </div>
</Card>

<style>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  h3 {
    margin: 10 auto;
    color: rgb(109, 55, 33);
  }
  .delete-item {
    text-align: right;
  }
  .updateDate {
    display: flex;
    position: relative;
    align-items: center;
  }
  .updateDate .label {
    color: rgb(255, 253, 253);
    font-size: 11px;
    padding-left: 5px;
    text-align: center;
  }
  .updateDate .date {
    padding-left: 5px;
    text-align: center;
  }

  .amountbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    text-align: center;
    background-color: bisque;
  }
  .amount {
    padding-left: 33%;
    text-align: center;
  }
  .freshnessAlert,
  .amountAlert {
    color: red;
  }

  .icon-button {
    font-size: medium;
    color: dimgrey;
    margin-right: 10px;
    cursor: pointer;
  }
  .buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .bestBefore {
    font-size: x-small;
  }
  .value {
    padding-top: 10px;
    font-size: large;
  }
  .tag {
    border-radius: 6px;
    padding: 5px;
    background-color: lightsalmon;
  }
  .sauerteig {
    background-color: lightgrey;
  }
</style>
